export const AcvAuctionsUrl = process.env.NEXT_PUBLIC_ACV_AUCTIONS_URL;
export const GatewayUrl = process.env.NEXT_PUBLIC_TYK_GATEWAY_URL;
export const IsAws = process.env.NEXT_PUBLIC_IS_AWS_ENVIRONMENT === 'true';
export const AnalyticsApiKey = process.env.NEXT_PUBLIC_ANALYTICS_API_KEY;
export const AnalyticsIsEnabled =
  process.env.NEXT_PUBLIC_ANALYTICS_IS_ENABLED === 'true';
export const AppTheme = process.env.NEXT_PUBLIC_APP_THEME;
export const HasuraUrl = process.env.NEXT_PUBLIC_HASURA_URL;
export const HasuraWebsocketUrl = process.env.NEXT_PUBLIC_HASURA_WS_URL;
export const InspectionUrl = process.env.NEXT_PUBLIC_INSPECTION_URL;
export const LogEnv = process.env.NEXT_PUBLIC_LOG_ENV;
export const LogKey = process.env.NEXT_PUBLIC_LOG_KEY;
export const LogEnabled = process.env.NEXT_PUBLIC_LOG_ENABLED === 'true';
export const MonkMessageSender = process.env.NEXT_PUBLIC_MONK_MESSAGE_SENDER;
export const BffUrl = process.env.NEXT_PUBLIC_BFF_URL;
// DRV-6676: routed through the BFF's REST API proxy instead of calling the
// upstream Cloud Run API directly, so the auth token stays server-side and
// never ships in the browser bundle.
export const ServiceUrl = `${BffUrl}/api/rest-api-handler`;
export const UsedCarClubUrl = process.env.NEXT_PUBLIC_USED_CAR_CLUB_URL;
export const IsDevEnvironment = process.env.NODE_ENV === 'development';
export const LoggerAppSourceName = 'clearcar-portal';
